import React, { useState, useEffect } from 'react';
import { TextField, InputAdornment, Popover, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ChromePicker } from 'react-color';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  colorCircle: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    borderRadius: '50%',
    border: `1px solid ${theme.palette.divider}`,
    cursor: 'pointer',
  },
}));

export const ToolbarTextInput = ({ onChange, value, prefix, label, type, isLiveUpdate = false, ...props }) => {
  const classes = useStyles();
  const [internalValue, setInternalValue] = useState(value);
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    let val = value;
    if (type === 'color' || type === 'bg') {
      val = value ? `rgba(${Object.values(value).join(',')})` : '';
    }
    setInternalValue(val);
  }, [value, type]);

  const handleClick = (event) => {
    if (type === 'color' || type === 'bg') {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const handleTextChange = (e) => {
    const newValue = e.target.value;
    setInternalValue(newValue);
    
    if (isLiveUpdate) {
        onChange(newValue);
    }
  }

  if (type !== 'color' && type !== 'bg') {
    return (
      <TextField
        label={label}
        value={internalValue || ''}
        onChange={handleTextChange}
        onBlur={() => {
          if (!isLiveUpdate) {
             onChange(internalValue);
          }
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') { 
            onChange(e.target.value); 
            e.target.blur(); 
          }
        }}
        variant="outlined"
        size="small"
        fullWidth
        {...props}
      />
    );
  }

  return (
    <div className={classes.root}>
      <TextField
        label={label}
        value={internalValue || ''}
        onChange={handleTextChange}
        onBlur={() => {
            if (!isLiveUpdate) {
                onChange(internalValue);
            }
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') { onChange(e.target.value); e.target.blur(); }
        }}
        variant="outlined"
        size="small"
        fullWidth
        InputProps={{
          endAdornment: ( 
            <InputAdornment position="end">
              <Box
                className={classes.colorCircle}
                style={{ background: internalValue }}
                onClick={handleClick}
              />
            </InputAdornment>
          ),
        }}
        InputLabelProps={{ shrink: true }}
        {...props}
      />
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <ChromePicker
          color={value || { r: 0, g: 0, b: 0, a: 1 }}
          onChange={(color) => onChange(color.rgb)} 
        />
      </Popover>
    </div>
  );
};
